import clsx from 'clsx'
import { ReactNode } from 'react'

import { CardType } from '../../types/types'

import cl from './card-top-panel.module.scss'

interface TopPanleProps {
	className?: string
	type?: CardType
	control?: ReactNode
	tagPanel: ReactNode
	controls?: ReactNode
}

export const CardTopPanel = (props: TopPanleProps) => {
	const { className, type = 'regular', tagPanel, control } = props

	return (
		<div className={clsx(cl[type], className)}>
			<div className={cl.tags}>{tagPanel}</div>
			{control && <div className={cl.control}>{control}</div>}
		</div>
	)
}
